import { supabase } from '../lib/supabase'
import type { Category, DbCategory } from '../types'

export async function listCategories(
  householdId: string,
  kind?: 'in' | 'out',
): Promise<Category[]> {
  let query = (supabase.from('categories') as any)
    .select('id, name, kind, spending_limit, parent_id')
    .eq('household_id', householdId)
    .order('name')

  if (kind) query = query.eq('kind', kind)

  const { data, error } = await query as { data: DbCategory[] | null; error: unknown }
  if (error) throw error

  return (data ?? []).map(row => ({
    id: row.id,
    name: row.name,
    kind: row.kind,
    amount: 0,
    spending_limit: row.spending_limit ?? null,
    parent_id: row.parent_id ?? null,
  }))
}

export async function createCategory(
  householdId: string,
  name: string,
  kind: 'in' | 'out',
  spending_limit?: number | null,
): Promise<Category> {
  const trimmed = name.trim()
  if (trimmed.length === 0 || trimmed.length > 50)
    throw new Error('Nome muito longo (máx. 50 caracteres)')

  const payload: Record<string, unknown> = { household_id: householdId, name: trimmed, kind }
  if (spending_limit != null) payload.spending_limit = spending_limit

  const { data, error } = await (supabase.from('categories') as any)
    .insert(payload)
    .select('id, name, kind, spending_limit')
    .single() as { data: DbCategory | null; error: unknown }
  if (error) throw error
  if (!data) throw new Error('Categoria não criada')
  return { id: data.id, name: data.name, kind: data.kind, amount: 0, spending_limit: data.spending_limit ?? null }
}

export async function renameCategory(id: string, name: string): Promise<void> {
  const trimmed = name.trim()
  if (trimmed.length === 0 || trimmed.length > 50)
    throw new Error('Nome muito longo (máx. 50 caracteres)')

  const { error } = await (supabase.from('categories') as any).update({ name: trimmed }).eq('id', id)
  if (error) throw error
}

export async function setCategoryLimit(id: string, limit: number | null): Promise<void> {
  const { error } = await (supabase.from('categories') as any)
    .update({ spending_limit: limit })
    .eq('id', id)
  if (error) throw error
}

export async function deleteCategory(id: string): Promise<void> {
  const { error } = await (supabase.from('categories') as any).delete().eq('id', id)
  if (error) throw error
}

export async function createSubcategory(
  householdId: string,
  name: string,
  parentId: string,
): Promise<Category> {
  const trimmed = name.trim()
  if (trimmed.length === 0 || trimmed.length > 50)
    throw new Error('Nome muito longo (máx. 50 caracteres)')

  const { data, error } = await (supabase.from('categories') as any)
    .insert({ household_id: householdId, name: trimmed, kind: 'out', parent_id: parentId })
    .select('id, name, kind, spending_limit, parent_id')
    .single() as { data: DbCategory | null; error: unknown }
  if (error) throw error
  if (!data) throw new Error('Subcategoria não criada')
  return { id: data.id, name: data.name, kind: data.kind, amount: 0, spending_limit: null, parent_id: data.parent_id }
}
